export enum CookiesItems {
  PRODUCTS_FOR_USER = 'productsForUser'
}
